module.exports = __webpack_public_path__ + "img/national.b2fddb95.svg";